import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './Auth/Login';
import OwnerDashboard from './Screens/Owner/OwnerDashboard';
import OrganisationAdminDashboard from './Screens/OrganisationAdmin/OrganisationAdminDashboard';
import AuditorDashboard from './Screens/Auditor/AuditorDashboard';
import BranchManagerDashboard from './Screens/BranchManager/BranchManagerDashboard';
import WareHouseManager from './Screens/WarehouseManager/WareHouseManager';
import CashierDashboard from './Screens/Cashier/CashierDashboard';
import SysAdminDashboard from './Screens/SystemAdmin/SysAdminDashboard';
import { isAuthenticatedSync } from './config/api';
import PWAInstallPrompt from './Components/PWAInstallPrompt';
// Import exchange rate utility to register global network restore listener
import './utils/exchangeRate';

// Protected Route component
const ProtectedRoute = ({ children }) => {
  return isAuthenticatedSync() ? children : <Navigate to="/login" replace />;
};

function App() {
  return (
    <>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/owner"
          element={
            <ProtectedRoute>
              <OwnerDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <OrganisationAdminDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/auditor"
          element={
            <ProtectedRoute>
              <AuditorDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/branch-manager"
          element={
            <ProtectedRoute>
              <BranchManagerDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/warehouse-manager"
          element={
            <ProtectedRoute>
              <WareHouseManager />
            </ProtectedRoute>
          }
        />
        <Route
          path="/cashier"
          element={
            <ProtectedRoute>
              <CashierDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/system-admin"
          element={
            <ProtectedRoute>
              <SysAdminDashboard />
            </ProtectedRoute>
          }
        />
        <Route path="/" element={<Navigate to="/login" replace />} />
      </Routes>
      <PWAInstallPrompt />
    </>
  );
}

export default App;
